const getNames = ({ selectedNodes }) => {
  return selectedNodes.map(({ name }) => name).join(':');
}

const nameForTealium = ({ brandName, abbrNameForTealium }) => {
  return brandName === 'gapfs' ? brandName : abbrNameForTealium;
}

export default props => {

  const {
    subcategoryName,
  } = props

  const pageName = `${nameForTealium(props)}:browse:${getNames(props)}`

  if(subcategoryName) {
    return `${pageName}:${subcategoryName}`
  }

  return pageName;
}

